module.exports = __webpack_public_path__ + "static/media/bill4.63413da7.png";